import "./Search.css";

export default function Search({ className = "", ...props }) {
  return (
    <div className="Search-field">
      <input
        className={`Search-input ${className}`}
        placeholder="Search for best offers..."
        {...props}
      />
      <span className="Search-icon" />
    </div>
  );
}
